export const PAYMENT_TYPE: Record<string, string> = {
    "prepayment": "Аванс",
    "postpayment": "Пiсляоплата",
};
